import './styles/app.css';

import {Application} from './application';

const application = new Application();

application.initialize();